import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ReloadPqqApplicantDataService {
  private reloadPqqApplicantDataSubject = new Subject<void>();
  reloadPqqApplicantData$ = this.reloadPqqApplicantDataSubject.asObservable();
  constructor(private dialog: MatDialog) {}

  handleCloseDialog(): void {
    this.dialog.closeAll();
  }
  reloadPqqApplicantData() {
    this.reloadPqqApplicantDataSubject.next();
  }
}
